import './../App.css';
import { useEffect, useState } from 'react';
import contacteznous from '../img/contactez-nous.jpg';
// import Map, { Source, Layer } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import Axios from 'axios';
import greybg from "../img/greybg.jpg";
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from '../constants/Constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TextareaAutosize } from '@mui/material';
import { Loader } from '../components/MainComponents';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

mapboxgl.accessToken = 'pk.eyJ1IjoiamFzb25zZW04OCIsImEiOiJjbDJwejY0bWgxdm9pM2JwazJpYnY3a3kwIn0.q2rVceGa016EwXht2oqU-Q'

const backgroundGrey = {
    backgroundImage: `url(${greybg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
};

function ContactezNous() {

    const [prenom, setPrenom] = useState("");
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");
    const [sujet, setSujet] = useState("");
    const [message, setMessage] = useState("");

    const [loading, setLoading] = useState("");

    const [toastmobile,setToastmobile] = useState(false)

    const [prenomStatus, setPrenomStatus] = useState(false);
    const [nomStatus, setNomStatus] = useState(false);
    const [emailStatus, setEmailStatus] = useState(false);
    const [sujetStatus, setSujetStatus] = useState(false);
    const [messageStatus, setMessageStatus] = useState(false);
    const [prenomError, setPrenomError] = useState('');
    const [nomError, setNomError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [sujetError, setSujetError] = useState('');
    const [messageError, setMessageError] = useState('');

    var formData = new FormData();
    formData.append("prenom", prenom);
    formData.append("nom", nom);
    formData.append("email", email);
    formData.append("sujet", sujet);
    formData.append("message", message);



    const mapFunc = () => {
        const map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [35.879679, 34.408551],
            zoom: 11,
            attributionControl: false
        }).addControl(new mapboxgl.FullscreenControl({ container: document.querySelector('mainContactez') }));
        const marker = new mapboxgl.Marker({ "color": "#e13939" })
            .setLngLat([35.879679, 34.408551])
            .addTo(map);
    }



    useEffect(() => {
        document.getElementById("nav-acceuil1").classList.remove('navSelected'); document.getElementById("nav-quisommenous1").classList.remove('navSelected'); document.getElementById("nav-nosolutions1").classList.remove('navSelected'); document.getElementById("nav-carrieres1").classList.remove('navSelected'); document.getElementById("nav-contactez1").classList.add('navSelected');
        document.getElementById("nav-acceuil").classList.remove('navSelected'); document.getElementById("nav-quisommenous").classList.remove('navSelected'); document.getElementById("nav-nosolutions").classList.remove('navSelected'); document.getElementById("nav-carrieres").classList.remove('navSelected'); document.getElementById("nav-contactez").classList.add('navSelected');
        document.documentElement.scrollTop = 0;
        mapFunc()
    }, [])


    const sendMessageApi = () => {
        if (nom === "") {
            setNomStatus(true);
            setNomError("Le nom ne peut pas être vide");
        } else {
            setNomStatus(false);
            setNomError("")
        }
        if (prenom === "") {
            setPrenomStatus(true);
            setPrenomError("Le prenom ne peut pas être vide");
            ;
        } else {
            setPrenomError("");
            setPrenomStatus(false);
        }
        if (email === "") {
            setEmailStatus(true);
            setEmailError("L'e-mail ne peut pas être vide");

        }
        else if (!email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
            setEmailStatus(true);
            setEmailError("Mauvais format d'email");
        }
        else {
            setEmailError("");
            setEmailStatus(false);
        }
        if (sujet === "") {
            setSujetStatus(true);
            setSujetError('Le sujet ne peut pas être vide');

        } else {
            setSujetStatus(false);
            setSujetError("");
        }
        if (message === "") {
            setMessageStatus(true);
            setMessageError("Le message ne peut pas être vide");
        } else {
            setMessageStatus(false);
            setMessageError("");
        }

        if (nom !== "" && prenom !== "" && email !== "" && email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) && sujet !== "" && message !== "") {
            postMessage();
        }
    }

    const postMessage = () => {

        setLoading(true);


        Axios.post(apiUrl + 'sendMessage.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then( response => {
                toast.success("Message envoyé");
                setNom('');
                setPrenom('');
                setEmail('');
                setSujet('');
                setMessage('');
                setLoading(false)

            })
            .catch(error => {
                toast.error("Erreur lors de l'envoi du message");
                setLoading(false);
            });
    }

    useEffect(() => {
        if (loading) {
            document.body.style.overflow = "hidden"
        }
        else {
            document.body.style.overflow = "visible"
        }
    }, [loading]);

    useEffect(() => {

        const handleResize = () => {
            
            if (window.innerWidth < 500) {
                setToastmobile(true);
            } else {
                setToastmobile(false)
            }
           
        }

        handleResize();
        window.addEventListener("resize", handleResize);

    }, [window.innerWidth]);


    return (

        <div id='mainContactez'>
            {loading && <div class="loader-background"><Loader /></div>}

            <div className='background-img-medium-cn' style={{
                backgroundImage: "url(" + contacteznous + ")",
                backgroundSize: 'cover',
            }}>
            </div>
            <div class="backgroundGrey">
                <div id='cvId' class="container carrieresCv">

                    <div class="alignCenter">
                        <div className='text-title color-blue bold'>Contactez Nous</div>
                    </div>
                    <form class=" g-3 needs-validation carrieresForm" novalidate>
                        <div class="marginTop30 carrieresInputs">
                            <div className='myinput-label'>Nom *</div>

                            <input className='borderInput inputSize' type="text" value={nom} onChange={(event) => setNom(event.target.value)} />
                            {nomStatus === true ? (
                                <div className='error-p'>{nomError}</div>
                            ) : <></>
                            }
                        </div>
                        <div class="marginTop30 carrieresInputs">
                            <div className='myinput-label'>Prénom *</div>

                            <input className='borderInput inputSize' type="text" value={prenom} onChange={(event) => setPrenom(event.target.value)} />

                            {prenomStatus === true ? (
                                <div className='error-p'>{prenomError}</div>
                            ) : <></>
                            }
                        </div>
                        <div class="marginTop30 carrieresInputs">
                            <div class="">
                                <div className='myinput-label'>Email *</div>

                                <input className='borderInput inputSize' type="text" value={email} onChange={(event) => setEmail(event.target.value)} />

                                {emailStatus === true ? (
                                    <div className='error-p'>{emailError}</div>
                                ) : <></>
                                }
                            </div>
                        </div>
                        <div class="marginTop30 carrieresInputs">
                            <div className='myinput-label'>Sujet *</div>

                            <input className='borderInput inputSize' type="text" value={sujet} onChange={(event) => setSujet(event.target.value)} />

                            {sujetStatus === true ? (
                                <div className='error-p'>{sujetError}</div>
                            ) : <></>
                            }
                        </div>
                        <div class="marginTop30 carrieresInputs2">

                            <div className='myinput-label'>Message *</div>
                            <textarea className='borderInput inputSizeArea' type="text" value={message} onChange={(event) => setMessage(event.target.value)}></textarea>
                            {messageStatus === true ? (
                                <div className='error-p'>{messageError}</div>
                            ) : <></>
                            }
                        </div>
                        {toastmobile ?  <ToastContainer
                            autoClose={3000}
                            theme="colored"
                            pauseOnHover={false}
                            closeButton={false}
                            hideProgressBar
                            icon={false}
                        /> :  <ToastContainer
                            style={{ position: "absolute", top: "50%", right: "-10%",width:"300px" }}
                            autoClose={3000}
                            theme="colored"
                            pauseOnHover={false}
                            closeButton={false}
                            hideProgressBar
                            icon={false}
                        />}
                    </form>
                    <div class="marginTop30 marginBottom30 cn-buttons-container2" >
                        <div class="">
                            <button className='btn-sendMsg2 mybtn-size' onClick={() => sendMessageApi()}>Envoyer</button>
                        </div>
                    </div>
                    <div class="map-info row" >
                        <div id="map" class="mapdivHeight col-sm-6"></div>
                        <div class="contactez-nous-info col-sm-6" style={backgroundGrey}>
                            <div class="map-flex cursor-pointer map-info-hover " onClick={() => { window.open('https://goo.gl/maps/V3MPhmjuf3brgYo8A', '_blank'); }}>
                                <i class="cn-icons fa fa-map-marker fa-fw" aria-hidden="true"></i>
                                <div class=" mapinfo-p">Zgharta, Lebanon</div>
                            </div>
                            <div class="map-flex cursor-pointer map-info-hover " onClick={() => { window.open('tel:0096106669064'); }}>
                                <div>
                                    <i class="cn-icons fa fa-phone fa-fw" aria-hidden="true" style={{ transform: "rotate(90deg)" }}></i>
                                </div>
                                <div>
                                    <div class=" mapinfo-p">+961 6 669 064</div>
                                </div>
                            </div>
                            <div class="map-flex cursor-pointer map-info-hover" onClick={() => { window.open('tel:0033189162720'); }}>

                                <div>
                                    <i class="cn-icons fa fa-phone fa-fw" aria-hidden="true" style={{ transform: "rotate(90deg)" }}></i>

                                </div>
                                <div>
                                    <div class="mapinfo-p">+33 1 89 16 27 20</div>
                                </div>
                            </div>
                            <div class="map-flex cursor-pointer map-info-hover" onClick={() => { window.open('https://www.linkedin.com/company/pro-p-group/about/', '_blank'); }}>
                                <i class="cn-icons fa fa-linkedin-square fa-fw" aria-hidden="true"></i>

                                <div class=" mapinfo-p">Pro-P Group</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="scroll-top-icon scroll-top myscroll-top cursor-pointer" onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })}><i class="fa fa-angle-up fa-2x"></i></div>
        </div>


    );
}

export default ContactezNous;
